import { render, staticRenderFns } from "./jion.vue?vue&type=template&id=6a3119ea&scoped=true&"
import script from "./jion.vue?vue&type=script&lang=js&"
export * from "./jion.vue?vue&type=script&lang=js&"
import style0 from "./jion.vue?vue&type=style&index=0&id=6a3119ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3119ea",
  null
  
)

export default component.exports